// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1rpuB","title":"AfterBackImages_title__2VZ5R","images":"AfterBackImages_images__SsqtT"};